import { css } from "@emotion/react";

export const wordWrap = css`
  overflow: auto;
  overflow-wrap: break-word;
  word-wrap: break-word;
`;
